'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectControls = function (_Component) {
  _inherits(SelectControls, _Component);

  function SelectControls() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectControls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectControls.__proto__ || Object.getPrototypeOf(SelectControls)).call.apply(_ref, [this].concat(args))), _this), _this.onDone = function (event) {
      // prevents the input from receiving focus and reopening menu
      event.preventDefault();
      var _this$props = _this.props,
          doneEnabled = _this$props.doneEnabled,
          handleDone = _this$props.handleDone;

      if (doneEnabled) {
        handleDone();
      }
    }, _this.onCancel = function (event) {
      // prevents the input from receiving focus and reopening menu
      event.preventDefault();
      var handleCancel = _this.props.handleCancel;

      handleCancel();
    }, _this.renderCancel = function (params) {
      return _react2.default.createElement(
        'a',
        { className: 'SelectControl', onClick: _this.onCancel },
        'Cancel'
      );
    }, _this.renderDone = function () {
      var _this$props2 = _this.props,
          mobileCloseOnChange = _this$props2.mobileCloseOnChange,
          doneEnabled = _this$props2.doneEnabled;

      if (mobileCloseOnChange) {
        return null;
      }
      return _react2.default.createElement(
        'a',
        {
          className: 'SelectControl ' + (doneEnabled ? '' : 'disabled'),
          onClick: _this.onDone
        },
        'Done'
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectControls, [{
    key: 'render',
    value: function render() {
      var menuIsOpen = this.props.menuIsOpen;

      if (!menuIsOpen) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'SelectControls' },
        this.renderCancel(),
        this.renderDone()
      );
    }
  }]);

  return SelectControls;
}(_react.Component);

SelectControls.propTypes = {
  doneEnabled: _propTypes2.default.bool.isRequired,
  handleDone: _propTypes2.default.func.isRequired,
  handleCancel: _propTypes2.default.func.isRequired,
  mobileCloseOnChange: _propTypes2.default.bool.isRequired
};

exports.default = SelectControls;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectControls.js
// module id = 541
// module chunks = 0